import { createLoggers } from '@highlight-cp/logger';

export const { error, warn, debug } = createLoggers({ tag: 'user-analytics' });
